import { SEO, SchemaMarkup } from '../components/seo';
import { BookOpen, UserCheck, MessageCircle, CalendarClock, Clock, ArrowRight } from 'lucide-react';

const items = [
  { icon: BookOpen, text: 'Achtergrondinformatie vinden over de verschillende deelonderwerpen rondom ongewenste omgangsvormen' },
  { icon: UserCheck, text: 'Lezen wat een vertrouwenspersoon doet en wat zij van een gesprek kunnen verwachten' },
  { icon: MessageCircle, text: 'Kiezen hoe ze contact willen: mail, bellen, WhatsApp of online spreekuur' },
  { icon: CalendarClock, text: 'Direct een tijd inplannen voor een gesprek' },
];

export function VoorMensen() {
  return (
    <>
      <SEO title="Voor mensen" description="Voor mensen binnen de organisatie: via praatuit.nl vind je informatie over ongewenste omgangsvormen en plan je direct een gesprek met de vertrouwenspersoon." canonicalUrl="/voor-mensen" />
      <SchemaMarkup
        type="webpage"
        pageUrl="https://puntuit.nl/voor-mensen"
        pageTitle="Voor mensen — PuntUit"
        pageDescription="Voor mensen binnen de organisatie: via praatuit.nl vind je informatie over ongewenste omgangsvormen en plan je direct een gesprek met de vertrouwenspersoon."
        breadcrumb={[
          { name: 'Home', url: '/' },
          { name: 'Voor mensen', url: '/voor-mensen' },
        ]}
      />
      <div className="pt-28">
        <section className="bg-[#0284c7] text-white">
          <div className="container py-24 md:py-32 max-w-4xl">
            <p className="text-sm mb-4">Voor mensen</p>
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Je eigen plek om te praten: praatuit.nl</h1>
            <p className="text-xl text-primary-100 mb-6">De omgeving voor mensen staat op praatuit.nl. Daar vind je informatie en kun je zelf bepalen hoe en wanneer je contact opneemt.</p>
            <a
              href="https://praatuit.nl"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
            >
              Ga naar praatuit.nl
              <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        </section>

        <section className="section-padding bg-white">
          <div className="container max-w-5xl">
            <h2 className="text-3xl font-bold text-gray-900 mb-3">Via praatuit.nl kunnen mensen:</h2>
            <p className="text-gray-700 mb-10 max-w-2xl">Alles op één plek — laagdrempelig en zonder verplichtingen.</p>
            <div className="grid md:grid-cols-2 gap-6">
              {items.map(({ icon: Icon, text }) => (
                <div key={text} className="flex items-start gap-4 bg-gray-50 rounded-2xl p-6 border border-gray-100">
                  <div className="w-10 h-10 rounded-lg bg-[#0284c7]/10 flex items-center justify-center flex-shrink-0">
                    <Icon className="w-5 h-5 text-[#0284c7]" />
                  </div>
                  <p className="text-gray-700">{text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="section-padding bg-gray-50">
          <div className="container max-w-4xl">
            <div className="bg-white rounded-2xl p-8 border border-gray-100 shadow-sm flex items-start gap-4">
              <div className="w-12 h-12 rounded-xl bg-[#0284c7]/10 flex items-center justify-center flex-shrink-0">
                <Clock className="w-6 h-6 text-[#0284c7]" />
              </div>
              <div>
                <p className="font-semibold text-gray-900 mb-1">Ruim bereikbaar</p>
                <p className="text-gray-700">De vertrouwenspersoon is op werkdagen bereikbaar van 09:00 tot 21:00 uur, zodat mensen ook buiten gebruikelijke werktijden contact kunnen opnemen.</p>
              </div>
            </div>
          </div>
        </section>

        <section className="section-padding bg-[#0284c7] text-white">
          <div className="container text-center max-w-3xl">
            <h2 className="text-3xl font-bold mb-4">Liever meteen iets regelen?</h2>
            <p className="text-white/80 text-lg mb-8">Op praatuit.nl plan je zelf direct een spreekuurafspraak in.</p>
            <a
              href="https://praatuit.nl"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white text-[#0284c7] px-8 py-4 rounded-xl font-semibold inline-flex items-center gap-2 hover:bg-gray-50 transition-colors"
            >
              Ga naar praatuit.nl
              <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        </section>
      </div>
    </>
  );
}
